<div class="container-fluid" style="margin-top: 15px">
  <div *ngIf="loading"><i class="fas fa-spinner fa-pulse"></i> Loading...</div>

  <div class="row">
    <div class="col-md-12">
      <span [style.color]="errorCount > 0 ? '#b00020' : 'inherit'">
        <b>{{ errorCount }}</b> error(s), <b>{{ warningCount }}</b> warning(s)
      </span>
      <button mat-raised-button class="piButton" style="margin-left: 15px" (click)="validate()">Validate</button>
      <a href="#" style="margin-left: 15px" (click)="selectedTab = validationTabIndex; false">View issues</a>
      <mat-checkbox style="margin-left: 25px" [(ngModel)]="showRetired" (change)="onShowRetiredChange()">Show retired</mat-checkbox>
      <span class="text-muted" style="margin-left: 15px">Changes apply to the user-facing export catalog immediately.</span>
    </div>
  </div>

  <div class="row" style="margin-top: 10px">
    <div class="col-md-5">
      <mat-form-field class="full-width">
        <mat-label>Endpoint</mat-label>
        <mat-select [(value)]="selectedEndPointId" (valueChange)="onEndPointChange()">
          <mat-option *ngFor="let e of endPointOptions" [value]="e.id">{{ e.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-md-7" style="margin-top: 10px">
      <button mat-raised-button class="piButton" (click)="newEndPoint()">New endpoint</button>&nbsp;
      <ng-container *ngIf="selectedEndPoint">
        <button mat-raised-button class="piButton" (click)="editEndPoint()">Edit endpoint</button>&nbsp;
        <button mat-raised-button class="piButton" (click)="toggleEndPointRetired()">{{ selectedEndPoint.retired ? "Restore" : "Retire" }}</button>&nbsp;
        <button mat-stroked-button (click)="showUsage(kinds.endPoint, selectedEndPoint.dodEndPointId, 'This endpoint')">Used by...</button>&nbsp;
        <button mat-raised-button class="piButton" (click)="testEndPoint()" [disabled]="testStarting || testRunning || selectedEndPoint.retired"
                title="Runs this endpoint's Fabric notebook for a few rows with its columns, to prove every selector">Test export</button>
      </ng-container>
    </div>
  </div>
  <div *ngIf="selectedEndPoint && selectedEndPoint.lastTestStatus" style="margin: 0 0 6px">
    <span [class]="testBadgeClass(selectedEndPoint.lastTestStatus)">Last test: {{ selectedEndPoint.lastTestStatus }}</span>
    <span class="text-muted" style="margin-left: 6px">{{ selectedEndPoint.lastTestUtc | date: "medium" }}</span>
    <i *ngIf="selectedEndPoint.lastTestStatus === 'Running'" class="fas fa-spinner fa-pulse" style="margin-left: 6px"></i>
    <pre *ngIf="selectedEndPoint.lastTestMessage" style="margin: 4px 0 0; white-space: pre-wrap; font-family: inherit; font-size: 90%">{{ selectedEndPoint.lastTestMessage }}</pre>
  </div>
  <p class="text-muted" *ngIf="selectedEndPoint && endPointIssueCount > 0" style="margin: 0 0 4px">
    {{ endPointIssueCount }} issue(s) on this endpoint - see the Validation tab.
  </p>

  <mat-tab-group style="margin-top: 6px" [(selectedIndex)]="selectedTab">
    <!-- COLUMNS -->
    <mat-tab label="Columns">
      <div class="row" style="margin-top: 10px" *ngIf="selectedEndPoint">
        <div class="col-md-5">
          <mat-form-field class="full-width">
            <mat-label>Showing</mat-label>
            <mat-select [(value)]="columnScope" (valueChange)="onScopeChange()">
              <mat-option *ngFor="let o of scopeOptions" [value]="o.value">{{ o.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-md-7" style="margin-top: 10px">
          <button mat-raised-button class="piButton" (click)="newColumn()">New column</button>
        </div>
      </div>

      <!-- Bulk actions on the selected columns -->
      <div *ngIf="selectedColumnIds.size > 0"
           style="position: sticky; top: 0; z-index: 5; background: #fff8e1; border: 1px solid #f0d58a; border-radius: 4px; padding: 8px 12px; margin: 10px 0">
        <div class="row">
          <div class="col-md-2" style="padding-top: 14px"><b>{{ selectedColumnIds.size }}</b> selected</div>
          <div class="col-md-3">
            <mat-form-field class="full-width">
              <mat-label>Move to</mat-label>
              <mat-select [(value)]="moveTargetValue">
                <mat-option *ngFor="let t of moveTargets" [value]="t.value">{{ t.label }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-2" style="padding-top: 10px">
            <button mat-raised-button class="piButton" (click)="moveSelected()" [disabled]="!canMove">Move</button>
          </div>
          <div class="col-md-3">
            <mat-form-field class="full-width">
              <mat-label>Set group</mat-label>
              <input matInput [(ngModel)]="bulkGroup" autocomplete="off" placeholder="blank clears the group" />
            </mat-form-field>
          </div>
          <div class="col-md-2" style="padding-top: 10px">
            <button mat-raised-button class="piButton" (click)="bulkSetGroup()" [disabled]="working">Apply</button>
          </div>
        </div>
        <div>
          <button mat-stroked-button (click)="bulkRetire(true)" [disabled]="working">Retire selected</button>&nbsp;
          <button mat-stroked-button (click)="bulkRetire(false)" [disabled]="working">Restore selected</button>&nbsp;
          <button mat-stroked-button (click)="testSelectedColumns()" [disabled]="working || testStarting || testRunning"
                  title="Runs the notebook for a few rows with only these columns">Test selected</button>&nbsp;
          <button mat-stroked-button (click)="clearSelection()" [disabled]="working">Clear</button>
          <span *ngIf="working" style="margin-left: 8px"><i class="fas fa-spinner fa-pulse"></i></span>
          <span class="text-muted" style="margin-left: 12px; font-size: 90%">Moving to another endpoint is refused for columns that saved layouts select. Retiring shows the affected layouts first.</span>
        </div>
      </div>

      <ng-container *ngFor="let group of columnGroups; trackBy: trackByGroup">
        <h5 style="margin-top: 14px; display: flex; align-items: center">
          <mat-checkbox style="margin-right: 6px" title="Select every column in this group"
            [checked]="groupAllSelected(group)" [indeterminate]="groupSomeSelected(group)" (change)="toggleGroup(group, $event.checked)"></mat-checkbox>
          {{ group.name }}
        </h5>
        <p class="text-muted" *ngIf="group.columns.length > 1" style="margin-bottom: 4px">Drag <span class="fas fa-grip-vertical"></span> to reorder.</p>
        <table class="table table-sm">
          <thead><tr><th></th><th>Output name</th><th>Selector</th><th>Description</th><th></th></tr></thead>
          <tbody cdkDropList [cdkDropListData]="group.columns" (cdkDropListDropped)="dropColumn(group, $event)">
            <tr *ngFor="let c of group.columns; trackBy: trackByColumn" cdkDrag [style.opacity]="c.retired ? 0.5 : 1">
              <td style="white-space: nowrap">
                <mat-checkbox [checked]="selectedColumnIds.has(c.dodEndPointColumnId)" (change)="toggleColumn(c.dodEndPointColumnId, $event.checked)" style="margin-right: 4px"></mat-checkbox>
                <span class="fas fa-grip-vertical" cdkDragHandle style="cursor: move; margin-right: 8px" title="Drag to reorder"></span>
                <a href="#" (click)="editColumn(c); false" title="Edit"><span class="fas fa-edit"></span></a>
              </td>
              <td>{{ c.name }}<span class="text-muted" *ngIf="c.retired"> (retired)</span></td>
              <td><code>{{ c.columnSelector }}</code></td>
              <td class="text-muted">{{ c.description }}</td>
              <td style="white-space: nowrap">
                <button mat-icon-button [matMenuTriggerFor]="colMenu" title="More"><span class="fas fa-ellipsis-v"></span></button>
                <mat-menu #colMenu="matMenu">
                  <button mat-menu-item (click)="renameSelector(c)">Rename selector...</button>
                  <button mat-menu-item (click)="renameColumnName(c)">Rename output name...</button>
                  <button mat-menu-item (click)="showUsage(kinds.column, c.dodEndPointColumnId, 'Column ' + c.name)">Used by...</button>
                  <button mat-menu-item (click)="setRetired(kinds.column, c.dodEndPointColumnId, !c.retired, 'Column')">{{ c.retired ? "Restore" : "Retire" }}</button>
                </mat-menu>
              </td>
            </tr>
          </tbody>
        </table>
      </ng-container>
      <p class="text-muted" *ngIf="selectedEndPoint && columnGroups.length === 0" style="margin-top: 10px">No columns yet.</p>
    </mat-tab>

    <!-- MEASURES -->
    <mat-tab label="Measures">
      <div style="margin-top: 10px" *ngIf="selectedEndPoint"><button mat-raised-button class="piButton" (click)="newMeasure()">New measure</button></div>
      <table class="table table-sm" style="margin-top: 10px">
        <thead><tr><th></th><th>Key</th><th>Title</th><th>Aggregates</th><th></th></tr></thead>
        <tr *ngFor="let m of measureRows" [style.opacity]="m.measure.retired ? 0.5 : 1">
          <td><a href="#" (click)="editMeasure(m); false" title="Edit"><span class="fas fa-edit"></span></a></td>
          <td>{{ m.measure.key }}<span class="text-muted" *ngIf="m.measure.retired"> (retired)</span></td>
          <td>{{ m.measure.title }}</td>
          <td>{{ m.aggregates }}</td>
          <td>
            <button mat-stroked-button (click)="showUsage(kinds.measure, m.measure.dodEndPointMeasureId, 'Measure ' + m.measure.key)">Used by</button>&nbsp;
            <button mat-stroked-button (click)="setRetired(kinds.measure, m.measure.dodEndPointMeasureId, !m.measure.retired, 'Measure')">{{ m.measure.retired ? "Restore" : "Retire" }}</button>
          </td>
        </tr>
        <tr *ngIf="measureRows.length === 0"><td></td><td class="text-muted" colspan="4">No measures on this endpoint.</td></tr>
      </table>
    </mat-tab>

    <!-- DIMENSIONS -->
    <mat-tab label="Dimensions">
      <div style="margin-top: 10px" *ngIf="selectedEndPoint"><button mat-raised-button class="piButton" (click)="newDimension()">New dimension</button></div>
      <table class="table table-sm" style="margin-top: 10px">
        <thead><tr><th></th><th>Key</th><th>Title</th><th></th></tr></thead>
        <tr *ngFor="let d of dimensionRows" [style.opacity]="d.retired ? 0.5 : 1">
          <td><a href="#" (click)="editDimension(d); false" title="Edit"><span class="fas fa-edit"></span></a></td>
          <td>{{ d.key }}<span class="text-muted" *ngIf="d.retired"> (retired)</span></td>
          <td>{{ d.title }}</td>
          <td>
            <button mat-stroked-button (click)="showUsage(kinds.dimension, d.dodEndPointDimensionId, 'Dimension ' + d.key)">Used by</button>&nbsp;
            <button mat-stroked-button (click)="setRetired(kinds.dimension, d.dodEndPointDimensionId, !d.retired, 'Dimension')">{{ d.retired ? "Restore" : "Retire" }}</button>
          </td>
        </tr>
        <tr *ngIf="dimensionRows.length === 0"><td></td><td class="text-muted" colspan="3">No dimensions on this endpoint.</td></tr>
      </table>
    </mat-tab>

    <!-- SUB-DATA -->
    <mat-tab label="Sub-data">
      <div style="margin-top: 10px" *ngIf="selectedEndPoint"><button mat-raised-button class="piButton" (click)="newSubData()">New sub-data</button></div>
      <p class="text-muted" style="margin-top: 6px">Sub-data is an additional file exported alongside the endpoint, produced by its own notebook. Its columns are managed on the Columns tab.</p>
      <table class="table table-sm">
        <thead><tr><th></th><th>Key</th><th>Title</th><th>File postfix</th><th>Last test</th><th></th></tr></thead>
        <tr *ngFor="let s of subDataRows" [style.opacity]="s.retired ? 0.5 : 1">
          <td><a href="#" (click)="editSubData(s); false" title="Edit"><span class="fas fa-edit"></span></a></td>
          <td>{{ s.key }}<span class="text-muted" *ngIf="s.retired"> (retired)</span></td>
          <td>{{ s.title }}</td>
          <td><code>{{ s.fileNamePostFix }}</code></td>
          <td>
            <span *ngIf="s.lastTestStatus" [class]="testBadgeClass(s.lastTestStatus)" [title]="s.lastTestMessage || ''">{{ s.lastTestStatus }}</span>
            <span *ngIf="s.lastTestStatus" class="text-muted" style="margin-left: 4px; font-size: 85%">{{ s.lastTestUtc | date: "short" }}</span>
            <div *ngIf="s.lastTestStatus === 'Failed' && s.lastTestMessage" style="font-size: 85%; color: #b00020; white-space: pre-wrap">{{ s.lastTestMessage }}</div>
          </td>
          <td>
            <button mat-stroked-button (click)="testSubData(s)" [disabled]="testStarting || testRunning || s.retired">Test</button>&nbsp;
            <button mat-stroked-button (click)="showUsage(kinds.subData, s.dodEndPointSubDataId, 'Sub-data ' + s.key)">Used by</button>&nbsp;
            <button mat-stroked-button (click)="setRetired(kinds.subData, s.dodEndPointSubDataId, !s.retired, 'Sub-data')">{{ s.retired ? "Restore" : "Retire" }}</button>
          </td>
        </tr>
        <tr *ngIf="subDataRows.length === 0"><td></td><td class="text-muted" colspan="5">No sub-data on this endpoint.</td></tr>
      </table>
    </mat-tab>

    <!-- FILTERS -->
    <mat-tab label="Filters">
      <p class="text-muted" style="margin-top: 10px">
        The filters offered when exporting this endpoint. They also decide which filter parameters are passed to its notebook.
      </p>
      <div *ngFor="let f of filterTypes">
        <mat-checkbox [checked]="filterSelection.has(f.filterTypeId)" (change)="toggleFilter(f.filterTypeId, $event.checked)">
          {{ f.title }} <span class="text-muted">({{ f.key }})</span>
        </mat-checkbox>
      </div>
      <div style="margin-top: 10px" *ngIf="selectedEndPoint"><button mat-raised-button class="piButton" (click)="saveFilters()">Save filters</button></div>
    </mat-tab>

    <!-- AGGREGATES -->
    <mat-tab label="Aggregates">
      <div style="margin-top: 10px"><button mat-raised-button class="piButton" (click)="newAggregate()">New aggregate</button></div>
      <p class="text-muted" style="margin-top: 6px">Shared by every endpoint's measures.</p>
      <table class="table table-sm">
        <thead><tr><th></th><th>Key</th><th>Description</th><th></th></tr></thead>
        <tr *ngFor="let a of aggregateRows" [style.opacity]="a.retired ? 0.5 : 1">
          <td><a href="#" (click)="editAggregate(a); false" title="Edit"><span class="fas fa-edit"></span></a></td>
          <td>{{ a.key }}<span class="text-muted" *ngIf="a.retired"> (retired)</span></td>
          <td class="text-muted">{{ a.description }}</td>
          <td><button mat-stroked-button (click)="setRetired(kinds.aggregateType, a.dodEndPointAggregateTypeId, !a.retired, 'Aggregate')">{{ a.retired ? "Restore" : "Retire" }}</button></td>
        </tr>
      </table>
    </mat-tab>

    <!-- IMPORT / EXPORT -->
    <mat-tab label="Import / Export">
      <admin-dod-transfer [endPoints]="definition.endPoints" (imported)="load()" (openValidation)="selectedTab = validationTabIndex"></admin-dod-transfer>
    </mat-tab>

    <!-- VALIDATION -->
    <mat-tab label="Validation">
      <div style="margin-top: 10px">
        <button mat-stroked-button (click)="setIssueFilter('all')" [disabled]="issueFilter === 'all'">All ({{ issues.length }})</button>&nbsp;
        <button mat-stroked-button (click)="setIssueFilter('errors')" [disabled]="issueFilter === 'errors'">Errors ({{ errorCount }})</button>&nbsp;
        <button mat-stroked-button (click)="setIssueFilter('warnings')" [disabled]="issueFilter === 'warnings'">Warnings ({{ warningCount }})</button>
      </div>
      <table class="table table-sm" style="margin-top: 10px">
        <thead><tr><th></th><th>Subject</th><th>Issue</th><th>Code</th></tr></thead>
        <tr *ngFor="let i of visibleIssues">
          <td><span class="fas" [ngClass]="i.severity === 1 ? 'fa-times-circle' : 'fa-exclamation-triangle'" [style.color]="i.severity === 1 ? '#b00020' : '#b26a00'"></span></td>
          <td><a href="#" (click)="goToIssue(i); false">{{ i.subject }}</a></td>
          <td>{{ i.message }}</td>
          <td class="text-muted">{{ i.code }}</td>
        </tr>
        <tr *ngIf="visibleIssues.length === 0"><td></td><td class="text-muted" colspan="3">No issues.</td></tr>
      </table>
    </mat-tab>
  </mat-tab-group>
</div>
